export const AUTH_BASIC =
  'Basic MzBjZWFjYzgtM2U4NC00ZjZiLTg0ZWUtN2JlZjdlOTI4MjBjOjNCaUdYa3dVcTNEYzhFa2NlTk14ZDgzTVJHWEFheVNXc0g0UkV4c2tSUDF3S1V2dVRhWkJwdW15YmphRXBSa3I=';
